<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SqiKCW/tc-custom/FC-9781528964999.jpg?1685327667848?1705766048085" alt="This image is the cover for the book Passage from India: Essays, Poems, and Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Passage from India: Essays, Poems, and Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>A product of two cultures and academic worlds--Indian and American--Dr. Satyam Sikha Moorty (S.S. Moorty) taught literature courses for thirty-one years at Southern Utah University, Cedar City, Utah, U.S.A. Award-winning essayist, poet, scholar, and editor, Dr. Moorty was a Fulbright Professor/Specialist in Moldova (thrice), Austria, Azerbaijan, and Yemen, and a Balkan Scholar in Bulgaria. He published his poetry in the U.S., India, England, South Africa, Canada, and Moldova. He has published two books: 1) "Distant Lands, Diverse Cultures" and 2) "Moldova: Vigorous Heritage and Variegated Traditions: Poems, Essays, Stories, and Speeches". His work examines his inter-cultural observations and experiences.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Satyam Sikha Moorty
      </h2>
      
      <p class="authorDescription body article">Originally from India, Satyam Sikha Moorty received his PhD in American Literature from the University of Utah, Salt Lake City, and taught for 31 years at Southern Utah University, Cedar City, Utah, courses such as F. Scott Fitzgerald, Shakespeare, Eastern Literatures in English translation (Indian, Chinese, and Japanese); was a Fulbright professor in Yemen, Moldova, (thrice), Austria, and Azerbaijan; was a Balkan scholar at the American University in Bulgaria; published scholarly articles in the U.S., India, France, Spain, Romania, Moldova, Azerbaijan, and Ukraine; published poetry in the U.S., India, Canada, the U.K., South Africa, Moldova, and Azerbaijan; published a book of poems and short stories titled Distant Lands, Diverse Cultures and Moldova: Vigorous Heritage and Variegated Traditions: Poems, Essays, Stories, and Speeches.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ed6007d